import { useEffect, useState } from 'react';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import AuthorSection from './components/AuthorSection';
import VideoSection from './components/VideoSection';
import OfferSection from './components/OfferSection';
import TestimonialSection from './components/TestimonialSection';
import OrderSection from './components/OrderSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import PaymentStatus from './components/PaymentStatus';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

function App() {
  const [isPaymentPage, setIsPaymentPage] = useState(false);

  useEffect(() => {
    // Check if this is the payment redirect page
    if (window.location.pathname === '/payment-status' || window.location.search.includes('billplz[id]')) {
      setIsPaymentPage(true);
      return;
    }

    const lenis = new Lenis({
      duration: 1.6,
      easing: (t) => 1 - Math.pow(1 - t, 4),
      smoothWheel: true,
      wheelMultiplier: 0.6,
      touchMultiplier: 1.5,
    });

    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);

    return () => lenis.destroy();
  }, [isPaymentPage]);

  if (isPaymentPage) {
    return (
      <div className="app-shell">
        <PaymentStatus />
      </div>
    );
  }

  return (
    <div className="app-shell">
      <HeroSection />
      <ProblemSection />
      <AuthorSection />
      <VideoSection />
      <TestimonialSection />
      <OfferSection />
      <OrderSection />
      <CTASection />
      <Footer />
    </div>
  );
}

export default App;
